import React, { useEffect, useState } from 'react'
import { Button, Input, Popup } from 'antd-mobile'
import CommunityMembersList from './CommunityMembersList'
import './styles/NewDmModal.css'

const NewDmModal = ({ open = false, onClose, onCreate, communityMembers = [] }) => {
  const [search, setSearch] = useState('')
  const [selectedUser, setSelectedUser] = useState(null)

  useEffect(() => {
    if (!open) {
      setSearch('')
      setSelectedUser(null)
    }
  }, [open])

  const filteredMembers = selectedUser
    ? communityMembers
    : (Array.isArray(communityMembers) ? communityMembers : []).filter(member =>
        ((member?.name || member?.username || '') + '').toLowerCase().includes((search || '').toLowerCase())
      )

  const handleSelectUser = (member) => {
    setSelectedUser(member)
    setSearch(member?.name || member?.username || '')
  }

  const handleInputChange = (value) => {
    setSearch(value || '')
    setSelectedUser(null)
  }

  return (
    <Popup
      visible={open}
      onMaskClick={onClose}
      onClose={onClose}
      position="bottom"
      bodyClassName="new-dm-modal"
    >
      <div className="new-dm-modal">
        <div className="new-dm-header">
          <span>New Message</span>
          <Button className="close-btn" onClick={onClose}>×</Button>
        </div>
        <Input
          type="text"
          placeholder="Search or select your community member"
          value={search}
          onChange={handleInputChange}
          className="new-dm-input"
        />
        <Button
          className="create-btn"
          disabled={!selectedUser}
          onClick={() => {
            if (selectedUser && onCreate) onCreate(selectedUser)
          }}
        >
          Create
        </Button>
        <CommunityMembersList
          members={filteredMembers}
          selectedUser={selectedUser}
          onSelectUser={handleSelectUser}
        />
      </div>
    </Popup>
  )
}

export default NewDmModal
